<template>
	<v-menu
		v-model="menu"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		offset-y
		class="background"
		full-width
		min-width="290px">

		<template v-slot:activator="{ on }">
			<v-text-field
				v-model="formated_datetime"
				prepend-inner-icon="schedule"
				readonly
				:class="{ dense_input: dense }"
				:solo="solo"
				:hint="hint"
				:rules="rules"
				:hide-details="hide_details"
				v-on="on">
				<template v-slot:label>
					<span v-if="param">
						{{ param | maestroParamLabel }}
					</span>
				</template>
			</v-text-field>
		</template>

		<v-card>
			<v-card-title class="headline pt-2 pb-0 primary color--text">
				{{ param | maestroParamLabel }}
			</v-card-title>
			<v-card-text class="pa-0">
				<v-container grid-list-xs fluid class="pa-0">
					<v-layout row wrap>
						<v-date-picker
							v-model="selected_date"
							color="primary color--text"
							class="background elevation-0"
							locale="fr-fr"
							reactive
							@change="updateValue()"
							:readonly="readonly"
							:first-day-of-week="1">
						</v-date-picker>
						<v-time-picker
							v-model="selected_time"
							:readonly="readonly"
							@change="updateValue()"
							color="primary color--text"
							class="background elevation-0 time-picker"
							format="24hr">
						</v-time-picker>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions class="background">
				<v-spacer></v-spacer>
				<v-btn
					color="primary color--text"
					class="text-none"
					@click="menu = false">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>

	</v-menu>
</template>

<script>
const moment = require('moment')
const defaultDate = () => {
	return moment().add(1, 'days').format('YYYY-MM-DD')
}
const defaultTime = () => {
	return moment().format('HH:mm')
}
export default {
	props: [
		'value',
		'rules',
		'param',
		'hint',
		'readonly',
		'solo',
		'dense',
		'hide_details'
	],
	data () {
		return {
			menu: false,
			selected_date: null,
			selected_time: null,
			formated_datetime: null
		}
	},
	watch: {
		value (val) {
			this.init(val)
		}
	},
	methods: {
		init (val) {
			if (!val) val = moment().add(1, 'days')
			this.selected_date = moment(val).format('YYYY-MM-DD')
			this.selected_time = moment(val).format('HH:mm')
			this.formated_datetime = moment(
				`${this.selected_date}T${this.selected_time}`
			).format('DD-MM-YYYY à HH:mm')
		},
		updateValue () {
			let selected_date = this.selected_date || defaultDate()
			let selected_time = this.selected_time || defaultTime()
			let dateTime = moment(`${selected_date}T${selected_time}`).format()
			this.$emit('change', dateTime)
		}
	},
	mounted () {
		this.init(this.value)
	}
}
</script>

<style lang="stylus" scoped>
.dense_input
	>>>.v-input__prepend-inner
		padding-left: 8px

>>>.v-picker__body
	background: transparent !important

.time-picker
	display: table-cell
	>>>.v-picker__title
		padding-top: 9px
		padding-bottom: 9px
		.v-time-picker-title
			justify-content: center
		.v-time-picker-title__time
			color: var(--v-color-base)
	>>>.v-time-picker-clock
		background: var(--v-background-darken1)
</style>



// WEBPACK FOOTER //
// src/components/field_datetime.vue